<template>
  <mdb-navbar position="top" color="red" dark :transparent="transparency" scrolling>
    <mdb-navbar-brand to="/">
      <img
        class="pentagon-brand"
        src="../assets/pentagon-logo.png"
        :alt="$t('navigation.brand_alt')"
      />
    </mdb-navbar-brand>
    <mdb-navbar-toggler style="max-width: 1140px">
      <mdb-navbar-nav left>
        <mdb-nav-item waves-fixed active to="/">{{ $t('navigation.home') }}</mdb-nav-item>
        <mdb-nav-item waves-fixed to="/Leden">{{ $t('navigation.members') }}</mdb-nav-item>
        <mdb-nav-item waves-fixed to="/Bestuur">{{ $t('navigation.board') }}</mdb-nav-item>
        <mdb-nav-item waves-fixed to="/Gallerij">{{ $t('navigation.gallery') }}</mdb-nav-item>
        <mdb-nav-item waves-fixed href="https://pentagonamsterdam.nl/login">{{ $t('navigation.login') }}</mdb-nav-item>
      </mdb-navbar-nav>
    </mdb-navbar-toggler>
  </mdb-navbar>
</template>

<script>
import {
  mdbContainer,
  mdbNavbar,
  mdbNavbarToggler,
  mdbNavbarNav,
  mdbNavItem,
  mdbDropdown,
  mdbDropdownToggle,
  mdbDropdownMenu,
  mdbDropdownItem,
  mdbNavbarBrand,
  mdbInput,
} from 'mdbvue';

export default {
  name: 'NavBar',
  components: {
    mdbContainer,
    mdbNavbar,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbNavItem,
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbDropdownItem,
    mdbNavbarBrand,
    mdbInput,
  },
  computed: {
    transparency() {
      return this.$store.state.navbar.transparent;
    },
  },
};
</script>

<style>
  .pentagon-brand {
    height: 50px;
    width: 50px;
  }
</style>
